import { useEffect, useState } from "react"
import { User } from "../components/user/user"
import { useLazyApi } from "./useLazyApi"
import { useAuthState } from "../contexts/authContext"

let cachedUser: User | null = null
let cachedUserTime: Date | null = null

export const useCurrentUser = (options?: { noAutoFetch: boolean }) => {
  const [user, setUser] = useState<User | null>(null)
  const authState = useAuthState()
  const [runFetch, { loading, error, data, errMsg }] = useLazyApi(
    "billing",
    "GetUserOrders"
  )

  useEffect(() => {
    if (!options?.noAutoFetch && authState.isLoggedIn()) {
      if (
        cachedUser &&
        cachedUserTime &&
        Date.now() - cachedUserTime.getTime() < 1000 * 30 * 1
      ) {
        setUser(cachedUser)
        return
      }

      cachedUser = null
      cachedUserTime = null
      runFetch({
        variables: {
          email: authState.email,
        },
      })
    }
  }, [authState?.email])

  useEffect(() => {
    if (data && data?.User) {
      const user = new User(data.User)
      cachedUser = user
      cachedUserTime = new Date()

      setUser(user)
    }
  }, [data])

  const fetch = (params: any) => {
    if (authState.isLoggedIn()) {
      runFetch({
        variables: {
          email: authState.email,
          ...params,
        },
      })
    }
  }

  return { user, fetch, loading, error, errMsg }
}
